import React from "react";
import SingleCollection from "./single";
import MultipleCollections from "./multiple";

const FeaturedCollection = ({ data }) => {
	const { splitDesignByDevice, showCollections } = data || {};

	if (splitDesignByDevice) {
		return (
			<>
				<div className="block md:hidden">
					<SingleCollection data={ data } />
				</div>
				<div className="hidden md:block">
					<MultipleCollections data={ data} />
				</div>
			</>
		);
	}

	if (showCollections) {
		return <MultipleCollections data={data} />;
	}

	return <SingleCollection data={data} />;
};

export default FeaturedCollection;
